// extracted by mini-css-extract-plugin
export var create = "index-module--create--e-H31";
export var label = "index-module--label--VZZZm";
export var customWordsContainer = "index-module--customWordsContainer--Qpe+Z";
export var customWordsHelper = "index-module--customWordsHelper--p0cMq";